module.exports = __webpack_public_path__ + "img/ommax-voices-6.6b2ce42a.jpg";